var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 17,
    viewBox: "0 0 34 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7776 7.98121C33.4649 7.65526 26.0149 0 16.4998 0C6.9848 0 -0.465572 7.65526 -0.777907 7.9809C-0.922228 8.13158 -1 8.3133 -1 8.49984C-1 8.68639 -0.922228 8.86811 -0.777907 9.01879C-0.465572 9.34474 6.9848 17 16.4998 17C26.0149 17 33.4649 9.34469 33.7776 9.01905C33.9221 8.86844 34 8.68671 34 8.50013C34 8.31356 33.9221 8.13182 33.7776 7.98121ZM16.4998 15.2414C9.491 15.2414 3.4206 10.1604 1.62363 8.4994C3.41828 6.8369 9.47596 1.75861 16.4998 1.75861C23.5083 1.75861 29.5783 6.83867 31.3761 8.5006C29.5814 10.163 23.5237 15.2414 16.4998 15.2414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4973 3.22412C12.68 3.22412 9.57422 5.59094 9.57422 8.50001C9.57422 11.4091 12.68 13.7759 16.4973 13.7759C20.3147 13.7759 23.4205 11.4091 23.4205 8.50001C23.4205 5.59094 20.3147 3.22412 16.4973 3.22412ZM16.4973 12.0172C13.9523 12.0172 11.882 10.4394 11.882 8.50001C11.882 6.56058 13.9524 4.98278 16.4973 4.98278C19.0423 4.98278 21.1127 6.56058 21.1127 8.50001C21.1127 10.4394 19.0424 12.0172 16.4973 12.0172Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword2);
export default __webpack_public_path__ + "static/media/Password2.481b2e977db907c5c665a794c978cb86.svg";
export { ForwardRef as ReactComponent };